module.exports = __webpack_public_path__ + "img/danye6.0105b426.jpg";